import React, {CSSProperties, FC, memo} from "react";
import {Radio, RadioChangeEvent} from "antd";
import {FormikProps} from "formik";
import {PaymentType, UpdateCourseAndBookingsInput, UpdateCourseAndBookingsResult} from "../../../../generated/graphql";
import {marginS} from "../../../../styles/layout";
import {PreviewBookingType} from "../PreviewBooking";
import i18n from "../../../../services/i18n";

type SwitchMonthlyPaymentProps = {
    formikProps: FormikProps<UpdateCourseAndBookingsInput>;
    booking: PreviewBookingType;
    preview?: UpdateCourseAndBookingsResult;
    disabled?: boolean;
};

const SwitchMonthlyPayment: FC<SwitchMonthlyPaymentProps> = ({formikProps, booking, preview, disabled = false}) => {
    const values = formikProps.values;
    const paymentMethod = booking.paymentMethod;

    // console.group("SwitchMonthlyPayment");
    // console.log("booking", booking);
    // console.log("paymentMethod", paymentMethod);
    // console.groupEnd();

    // const paymentIsEsr = state.typeOfPaymentMethod === PaymentTransferType.Esr;

    const buttonStyle: CSSProperties = {
        flex: 1,
        textAlign: "center",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    };

    const currentBookingsData = formikProps.values.updatedBookingsData ?? [];
    const currentBooking = currentBookingsData.find((bookingX) => bookingX.id === booking.id);

    const handleChange = (e: RadioChangeEvent) => {
        if (currentBooking) {
            currentBooking.paymentType = e.target.value;
            const updatedBookingsData = [...currentBookingsData];

            updatedBookingsData.forEach((bookingX) => {
                if (bookingX.id === booking.id) {
                    bookingX.paymentType = e.target.value;

                    // Bug-Fix 2026-05-04 (Toggle Custom→Monthly→Custom):
                    // scheduledPayments NICHT mehr beim Wechsel auf Monthly/PrePaid
                    // löschen. Das Backend zwingt customScheduledPayments serverseitig
                    // ohnehin auf undefined, wenn paymentType !== Custom (siehe
                    // lessonBooking.service.ts: editMultipleBookings ~Z. 1190 sowie
                    // editLessonBooking Z. 501). Wenn der Frontend-Wert hier auf
                    // undefined gesetzt wurde, gingen die Original-Custom-Raten
                    // beim Zurückwechseln zu "Individuell" verloren — das Backend
                    // fiel in den PrePaid-Zweig (createPaymentPreview.ts:98-150),
                    // generierte 1 statt N Raten und triggerte den Excess-Pfad,
                    // der invoiced-Excess-Raten persistent gelöscht hat.
                    // Dadurch dass scheduledPayments hier durchgereicht bleiben,
                    // hat das Backend bei Custom-Rückwahl wieder die Original-IDs
                    // und kann sauber den Custom-Plan wiederherstellen.
                }
            });

            formikProps.setFieldValue("updatedBookingsData", updatedBookingsData);
        }
    };

    return (
        <Radio.Group
            style={{width: "100%", display: "flex", gap: 0, justifyContent: "space-evenly", marginTop: marginS}}
            buttonStyle="solid"
            onChange={handleChange}
            value={currentBooking?.paymentType}
            disabled={disabled}
        >
            {/* Das Büro darf jede Zahlweise buchen, die Kurs-Haken gelten nur für Kunden. Online-Zahlung und Einzahlungsschein sperren Monatlich. */}
            <Radio.Button style={buttonStyle} value={PaymentType.PrePaid}>
                {i18n.containers.bookings.BookingSummary.prePay()}
            </Radio.Button>
            {!values.allowMolliePayment && !paymentMethod?.esr && (
                <Radio.Button style={buttonStyle} value={PaymentType.Monthly}>
                    {i18n.containers.bookings.BookingSummary.monthlyPay()}
                </Radio.Button>
            )}
            <Radio.Button style={buttonStyle} value={PaymentType.Custom}>
                {i18n.containers.bookings.BookingSummary.individualPayments()}
            </Radio.Button>
        </Radio.Group>
    );
};

export default memo(SwitchMonthlyPayment);

export const DummySwitchMonthlyPayment = ({
    paymentType,
    allowUpFrontPayment,
    allowMonthlyPayment,
}: {
    paymentType: PaymentType;
    allowUpFrontPayment?: boolean | undefined;
    allowMonthlyPayment?: boolean | undefined;
}) => {
    const buttonStyle: CSSProperties = {
        flex: 1,
        textAlign: "center",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    };

    // const paymentType = booking.paymentType;

    return (
        <Radio.Group
            style={{width: "100%", display: "flex", gap: 0, justifyContent: "space-evenly", marginTop: marginS}}
            buttonStyle="solid"
            // onChange={handleChange}
            value={paymentType}
            disabled={true}
        >
            {allowUpFrontPayment && (
                <Radio.Button style={buttonStyle} value={PaymentType.PrePaid}>
                    {i18n.containers.bookings.BookingSummary.prePay()}
                </Radio.Button>
            )}
            {allowMonthlyPayment && (
                <Radio.Button style={buttonStyle} value={PaymentType.Monthly}>
                    {i18n.containers.bookings.BookingSummary.monthlyPay()}
                </Radio.Button>
            )}
            <Radio.Button style={buttonStyle} value={PaymentType.Custom}>
                {i18n.containers.bookings.BookingSummary.individualPayments()}
            </Radio.Button>
        </Radio.Group>
    );
};
